import { styled } from '@mui/material/styles';
import { Box } from '@mui/material';


export const BoxStatus = styled(Box)<{ color: string }>(({ theme ,color }) => ({
    width: 19,
    height: 19,
    backgroundColor: color,
    margin: 'auto'
}))